module.exports = __webpack_public_path__ + "img/img_shou@2x.e74ce51e.png";